<template>
  <form v-if="!loading" @submit.prevent="submit">
    <FormGroup name="cvr" label="CVR" help-text="The company's CVR number." :error="(errors.cvr || [])[0]">
      <div class="row">
        <div class="col-xs-16">
          <input name="cvr" placeholder="CVR" class="form-control" type="text" v-model="data.cvr">
        </div>

        <div class="col-xs-8">
          <button type="button" class="btn btn-white btn-block" @click="lookup">
            <i class="fa fa-search"/> Lookup
          </button>
        </div>
      </div>
    </FormGroup>

    <TextFormGroup
        v-model="data.name"
        name="name"
        label="Name"
        help-text="The name of the company."
        :error="(errors.name || [])[0]"
    />

    <div class="row">
      <div class="col-sm-8">
        <TextFormGroup
            v-model="data.address.street_name"
            name="address.street_name"
            label="Street Name"
            :error="(errors['address.street_name'] || [])[0]"
        />
      </div>

      <div class="col-sm-4">
        <TextFormGroup
            v-model="data.address.street_number"
            name="address.street_number"
            label="Number"
            :error="(errors['address.street_number'] || [])[0]"
        />
      </div>

      <div class="col-sm-4">
        <TextFormGroup
            v-model="data.address.street_letter"
            name="address.street_letter"
            label="Letter"
            :error="(errors['address.street_letter'] || [])[0]"
        />
      </div>

      <div class="col-sm-4">
        <TextFormGroup
            v-model="data.address.street_floor"
            name="address.street_floor"
            label="Floor"
            :error="(errors['address.street_floor'] || [])[0]"
        />
      </div>

      <div class="col-sm-4">
        <TextFormGroup
            v-model="data.address.street_location"
            name="address.street_location"
            label="Location"
            :error="(errors['address.street_location'] || [])[0]"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-8">
        <TextFormGroup
            v-model="data.address.zip_code"
            name="address.zip_code"
            label="Zip Code"
            :error="(errors['address.zip_code'] || [])[0]"
        />
      </div>

      <div class="col-sm-16">
        <TextFormGroup
            v-model="data.address.city"
            name="address.city"
            label="City"
            :error="(errors['address.city'] || [])[0]"
        />
      </div>
    </div>

    <SelectFormGroup
        v-model="data.address.country"
        name="address.country"
        label="Country"
        :error="(errors['address.country'] || [])[0]"
        :options="countryOptions"
    />

    <button type="submit" class="btn btn-black btn-block">
      <i class="fa fa-save"></i> Save
    </button>
  </form>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {FormGroup, SelectFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    project: {
      required: true
    },
  },

  data() {
    return {
      data: {
        address: {country: 'DK'},

        tags: []
      },

      countries: null,

      loading: true,

      shared: store
    }
  },

  computed: {
    countryOptions() {
      return this.countries.map(country => ({
        value: country.id,
        label: country.attributes.name
      }))
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/countries').then(response => {
        this.countries = response.data.data

        this.loading = false
      })
    },

    lookup() {
      if (!this.data.cvr) {
        return
      }

      http.get('/api/v2/cvr-companies/' + this.data.cvr).then(response => {
        this.data = {
          ...this.data,
          ...response.data.data.attributes,

          address: {
            ...response.data.data.attributes.address,
            country: this.data.address.country,
          },
        }
      })
    },

    submit() {
      http.post('/api/v2/companies', this.data).then(response => {
        http.post('/api/v2/project-leads', {company_id: response.data.data.id, project_id: this.project.id})
            .then(response => {
              notify.success('The project lead was saved')

              this.$emit('created', response.data.data)
            })
      })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
